const HOVER_CAPABLE_QUERY = "(hover: hover) and (pointer: fine)";

export const getCanHover = () => typeof window !== "undefined" && window.matchMedia(HOVER_CAPABLE_QUERY).matches;
